module.exports = "/images/vendor/flag-icon-css/flags/4x3/br.svg?6cb7383b4f639abc8d1cce9761c245e7";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/br.svg
// module id = 4Scc
// module chunks = 66